import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './components/main/main.component';

const routes: Routes = [
    /*  {
       path: "cargue",
       component:  CargueComponent
     }, */
    {
        path: "",
        component: MainComponent
    },
    { path: "**", redirectTo: "dashboard", pathMatch: "prefix" },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CajerosRoutingModule { }
